<div class="login-shell">

  <div class="login-brand">
    <div class="brand-orbs" aria-hidden="true">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>

    <div class="brand-header">
      <div class="brand-logo">
        <img src="assets/manager-favicon.svg" alt="iManager" />
        <span class="brand-name"><span class="brand-i">i</span>Manager</span>
      </div>
    </div>

    <div class="brand-inner">
      <div class="brand-copy">
        <h2 class="brand-title">Acesso<br>restrito.</h2>
        <p class="brand-subtitle">
          O portal de gestão é destinado a gestores com permissão de acesso habilitada.
        </p>
      </div>
    </div>

    <div class="brand-footer">
      <span>© 2026 iManager — Portal de Gestão</span>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="login-card">

      <div class="card-logo-mobile" aria-hidden="true">
        <img src="assets/manager-favicon.svg" alt="iManager" />
      </div>

      <div class="block-icon">
        <i class="pi pi-ban"></i>
      </div>

      <div class="card-headline">
        <h1>Acesso não autorizado</h1>
        <p>
          Você não tem permissão para acessar o portal.<br>
          Entre em contato com seu gestor para solicitar acesso.
        </p>
      </div>

      <button
        pButton
        type="button"
        label="Voltar ao login"
        class="login-btn"
        icon="pi pi-arrow-left"
        (click)="voltarAoLogin()">
      </button>

    </div>
  </div>

</div>
